import Swiper, { FreeMode } from "swiper";

export default () => ({
  swiper: null,
  isMobile: null,
  currentSlide: null,
  collectionIndex: 0,

  init() {
    this.setIsMobile();
  },

  initItemsDesktop(index) {
    // Set initial widths to enable transitions.
    var wrapper =
      document &&
      document.getElementById(`categoriesItemWrapperDesktop-${index}`);

    var textWrapper =
      document &&
      document.getElementById(`categoriesTextWrapperDesktop-${index}`);
    var text =
      document && document.getElementById(`categoriesTextDesktop-${index}`);

    wrapper.style.width = `${text.getBoundingClientRect().width + 24}px`;
    textWrapper.style.width = `${text.getBoundingClientRect().width}px`;
  },

  changeCollection(index) {
    if (index !== this.collectionIndex) {
      if (this.isMobile) {
        this.swiper.destroy();
        this.swiper = null;
      }
      this.collectionIndex = index;
    }
  },

  initSlider() {
    this.currentSlide = 1;
    this.swiper = new Swiper(document.getElementById(`slider`), {
      preloadImages: false,
      freeMode: {
        momentum: false,
        sticky: true,
      },
      speed: 100,
      slidesPerView: 11,
      centeredSlides: true,
      loop: true,
      modules: [FreeMode],
    });

    const setCurrentIndex = (index) => {
      this.currentSlide = index;
    };

    this.swiper.on("slideChange", function () {
      setCurrentIndex(this.realIndex + 1);
    });
  },

  setIsMobile() {
    this.isMobile = window.innerWidth < 1024 ? true : false;
  },
});
